import { useState, useEffect } from 'react';
import './ScrollButton.css';

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);
  
  // Function to check scroll position and update button visibility
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };
  
  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  // Set up scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);
  
  return (
    <div className={`scroll-to-top ${visible ? 'visible' : ''}`}>
      <button 
        onClick={scrollToTop}
        aria-label="Scroll to top"
        className="scroll-btn"
      >
        <i className="uil uil-arrow-up scroll-icon"></i>
        <span className="scroll-tooltip">Top</span>
      </button>
    </div>
  );
};

export default ScrollButton;